import React from 'react';
import { useTranslation } from 'react-i18next';

import classnames from 'classnames';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';

const AppointmentListHeaders = ({
  columns,
  sortColumn,
  sortOrder,
  onHeaderClick,
}) => {
  const { t } = useTranslation();

  return (
    <tr>
      {columns.map((c) => {
        const upChevronClassNames = classnames({
          fa: true,
          'fa-chevron-up': true,
          hidden: !c.sort,
          'font-bold': sortOrder === 'asc' && sortColumn === c.attribute,
          'text-grey': sortColumn !== c.attribute || sortOrder !== 'asc',
        });
        const downChevronClassNames = classnames({
          fa: true,
          'fa-chevron-down': true,
          hidden: !c.sort,
          'font-bold': sortOrder === 'desc' && sortColumn === c.attribute,
          'text-grey': sortColumn !== c.attribute || sortOrder !== 'desc',
        });

        const tooltip = c.columnInfo ? (
          <Tooltip id={`column-info-${c.attribute}`}>{t(c.columnInfo)}</Tooltip>
        ) : null;

        const localeNamespace = c.localeNamespace
          ? c.localeNamespace
          : 'common';

        let headerClassNames = classnames({
          'cursor-pointer': true,
          sticky: c.pinned === true,
          'right-0': c.pinned === true,
          'bg-gray-50': c.pinned === true,
        });

        if (c.headerClassName) {
          headerClassNames = `${headerClassNames} ${c.headerClassName}`;
        }

        return (
          <th onClick={() => onHeaderClick(c)} className={headerClassNames}>
            <div className="flex space-x-1 items-center">
              <span className="font-bold text-sm">{t(c.name)}</span>
              <OverlayTrigger overlay={tooltip} placement="right">
                <i className="fa fa-info-circle" />
              </OverlayTrigger>
              <div className="flex flex-col">
                <i style={{ fontSize: 10 }} className={upChevronClassNames} />
                <i style={{ fontSize: 10 }} className={downChevronClassNames} />
              </div>
            </div>
          </th>
        );
      })}
    </tr>
  );
};

export default function AppointmentsList({
  appointments,
  columns,
  userType,
  sortColumn,
  sortOrder,
  onHeaderClick,
  onEditActionClick,
  onStatusActionClick,
}) {
  return (
    <div className="overflow-x-auto">
      <table className="default-table">
        <thead>
          <AppointmentListHeaders
            sortOrder={sortOrder}
            sortColumn={sortColumn}
            userType={userType}
            columns={columns}
            onHeaderClick={onHeaderClick}
          />
        </thead>
        <tbody>
          {appointments.map((row) => {
            return (
              <tr>
                {columns.map((c) => {
                  const value = row[c.attribute];
                  return c.render(
                    value,
                    row,
                    userType,
                    onEditActionClick,
                    onStatusActionClick,
                  );
                })}
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
}
